var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.npc)?_c('div',{staticClass:"d-flex flex-column align-center"},[_c('div',{attrs:{"id":"avatar"}},[_c('AbstractNPC',{staticClass:"mx-auto animated-avatar",attrs:{"avatar":_vm.npc.avatar,"height":100,"width":100}})],1),_c('div',[_vm._v(" "+_vm._s(_vm.npc.name)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }